module.exports = __webpack_public_path__ + "static/media/hero.38a0fe85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/contact/hero.jpg
// module id = 914
// module chunks = 0